/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
// eslint-disable-line import/no-webpack-loader-syntax
/* eslint-disable react/no-array-index-key */
/* eslint-disable @typescript-eslint/no-unused-expressions */
import React, { useEffect, useState } from 'react';

// Redux
import { useDispatch, useSelector } from 'react-redux';

// clsx
// @ts-ignore
import clsx from 'clsx';

// Material
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';

// Icons
import CloseIcon from '@material-ui/icons/Close';

// Actions
import {
  setClose,
  setSecondOpenLoading,
  setSecondClose,
} from 'store/ducks/dialogs/actions';

// Helpers
import { maskCNPJ } from 'helpers/maskers';

// Actions
import { setCSVFullIsChecked } from 'store/ducks/reports/actions';

// Contants
import IMAGES from 'constants/images';

// Types
import { ApplicationState } from 'store';

// Functions
import { MyWorkerWithParam, WebWorker } from 'components/DialogueExport';

// Styles
import useStyles from './Dialogue.styles';
import { DefaultDocument, HorizontalDocument } from 'icons/Document_File';

interface DialogueInterface {
  handleDownloadCsv: () => void;
  handlePrintPdf: () => void;
  handleDownloadXls: () => void;
  beforePrint?: () => void;
  pdf: boolean;
  pdfName?: string;
  simplePdf?: boolean;
  simplePdfData?: any;
  columnsPerPage?: number;
  csv: boolean;
  xls: boolean;
  setIsPrinting?: (param: boolean) => void;
  isMounted?: 'initalState' | 'loading' | 'notLoading';
  headerFontSize?: number;
  bodyFontSize?: number;
  isExtract?: boolean;
  csvFull?: boolean;
  handleDownloadCsvFull?: () => void;
  totalRows?: boolean;
  csvLabel?: string;
  csvFullLabel?: string;
}

const Dialogue: React.FC<DialogueInterface> = ({
  handleDownloadCsv,
  handlePrintPdf,
  handleDownloadXls,
  beforePrint,
  pdf,
  pdfName,
  simplePdf = false,
  simplePdfData,
  columnsPerPage = 0,
  csv,
  xls,
  setIsPrinting,
  isMounted,
  headerFontSize,
  bodyFontSize,
  isExtract,
  csvFull,
  handleDownloadCsvFull = null,
  totalRows,
  csvLabel = 'CSV',
  csvFullLabel = 'CSV Completo',
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const [pdfTextLoading, setPdfTextLoading] = useState<boolean | undefined>(
    undefined,
  );
  const [simplePdfIsChecked, setSimplePdfIsChecked] = useState(false);
  const [simplePdfOrientation, setSimplePdfOrientation] = useState<
    'vertical' | 'horizontal' | null
  >(null);
  const [pdfIsChecked, setPdfIsChecked] = useState(false);
  const [csvIsChecked, setCsvIsChecked] = useState(false);
  const [csvFullIsChecked, setCsvFullIsChecked] = useState(false);
  const [xlsIsChecked, setXlsIsChecked] = useState(false);

  const userFirebaseData = useSelector(
    (state: ApplicationState) => state.users.firebaseData || null,
  );

  const transportOperatorData = useSelector(
    (state: ApplicationState) =>
      state.transportOperators.transportOperatorSelected,
  );

  useEffect(() => {
    if (pdfTextLoading) {
      const userFirebaseUid = userFirebaseData?.uid
        ? `${simplePdfData?.userName
          ? `${simplePdfData?.userName} - ${simplePdfData?.userId?.slice(
            0,
            15,
          )}`
          : userFirebaseData?.uid?.slice(0, 15)
        } `
        : '--';

      const transportOperatorCnpj = transportOperatorData?.cnpj
        ? maskCNPJ(transportOperatorData?.cnpj)
        : '--';
      const userId = simplePdfData?.userId;

      const workerInstanceWithParams = new WebWorker(
        MyWorkerWithParam(
          columnsPerPage,
          simplePdfData,
          () => setPdfTextLoading(false),
          transportOperatorData?.photoUrl,
          userFirebaseUid,
          transportOperatorData?.name || '---',
          transportOperatorCnpj,
          pdfName || '',
          headerFontSize,
          bodyFontSize,
          isExtract,
          userId,
          totalRows,
          simplePdfOrientation === 'horizontal',
        ),
      );

      (workerInstanceWithParams as Worker).addEventListener(
        'message',
        (e: any) => {
          // do nothing
        },
      );
    }
  }, [pdfTextLoading]);

  useEffect(() => {
    if (pdfTextLoading) {
      dispatch(
        setSecondOpenLoading({
          title: 'Gerando pdf...',
        }),
      );
    } else if (pdfTextLoading !== undefined) dispatch(setSecondClose());
  }, [pdfTextLoading]);

  useEffect(() => {
    dispatch(
      setCSVFullIsChecked({
        csvFullIsChecked,
      }),
    );
  }, [csvFullIsChecked]);

  return (
    <>
      <Grid item>
        <Box display='flex' alignItems='center' justifyContent='flex-end'>
          <IconButton
            className={classes.closeButton}
            onClick={() =>
              dispatch(
                setClose({
                  open: false,
                }),
              )
            }>
            <CloseIcon />
          </IconButton>
        </Box>
        <Box p={1}>
          <Typography className={classes.title}>
            Em quais formatos deseja baixar este lote de relatório?
          </Typography>
        </Box>

        <Grid
          className={classes.contentBoxs}
          container
          xl={12}
          lg={12}
          md={12}
          sm={12}
          xs={12}>
          <div
            className={`${!pdf ? classes.hiden : classes.boxInput} ${pdfIsChecked ? classes.selectedBox : ''
              }`}
            onClick={() => setPdfIsChecked(!pdfIsChecked)}>
            <Typography className={classes.labelTop}>PDF</Typography>
            <div className={classes.divider} />
            <div className={classes.iconContainer}>
              <img
                className={classes.fileIcon}
                src={
                  pdfIsChecked
                    ? IMAGES.REPORTS_ICONS.PDF_CHECKED
                    : IMAGES.REPORTS_ICONS.PDF
                }
                alt='PDF'
              />
            </div>
            {pdfIsChecked && (
              <div className={classes.checkIcon}>
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  width='20'
                  height='20'
                  viewBox='0 0 24 24'
                  fill='currentColor'>
                  <circle cx='12' cy='12' r='10' fill='currentColor' />
                  <path
                    d='M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z'
                    fill='white'
                  />
                </svg>
              </div>
            )}
          </div>

          <div
            className={`${!simplePdf ? classes.hiden : classes.boxInput} ${simplePdfIsChecked ? classes.selectedBox : ''
              }`}>
            <div onClick={() => setSimplePdfIsChecked(!simplePdfIsChecked)}>
              <Typography className={classes.labelTop}>PDF Texto</Typography>
              <div className={classes.divider} />
              <div className={classes.iconContainer}>
                <img
                  className={classes.fileIcon}
                  src={
                    simplePdfIsChecked
                      ? IMAGES.REPORTS_ICONS.PDF_CHECKED
                      : IMAGES.REPORTS_ICONS.PDF
                  }
                  alt='PDF'
                />
              </div>
              {simplePdfIsChecked && (
                <div className={classes.checkIcon}>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='20'
                    height='20'
                    viewBox='0 0 24 24'
                    fill='currentColor'>
                    <circle cx='12' cy='12' r='10' fill='currentColor' />
                    <path
                      d='M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z'
                      fill='white'
                    />
                  </svg>
                </div>
              )}
            </div>
          </div>

          <div
            className={`${!csv ? classes.hiden : classes.boxInput} ${csvIsChecked ? classes.selectedBox : ''
              }`}
            onClick={() => setCsvIsChecked(!csvIsChecked)}>
            <Typography className={classes.labelTop}>{csvLabel}</Typography>
            <div className={classes.divider} />
            <div className={classes.iconContainer}>
              <img
                className={classes.fileIcon}
                src={
                  csvIsChecked
                    ? IMAGES.REPORTS_ICONS.CSV_CHECKED
                    : IMAGES.REPORTS_ICONS.CSV
                }
                alt='CSV simples'
              />
            </div>
            {csvIsChecked && (
              <div className={classes.checkIcon}>
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  width='20'
                  height='20'
                  viewBox='0 0 24 24'
                  fill='currentColor'>
                  <circle cx='12' cy='12' r='10' fill='currentColor' />
                  <path
                    d='M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z'
                    fill='white'
                  />
                </svg>
              </div>
            )}
          </div>

          <div
            className={`${!csvFull ? classes.hiden : classes.boxInput} ${csvFullIsChecked ? classes.selectedBox : ''
              }`}
            onClick={() => setCsvFullIsChecked(!csvFullIsChecked)}>
            <Typography className={classes.labelTop}>{csvFullLabel}</Typography>
            <div className={classes.divider} />
            <div className={classes.iconContainer}>
              <img
                className={classes.fileIcon}
                src={
                  csvFullIsChecked
                    ? IMAGES.REPORTS_ICONS.CSV_CHECKED
                    : IMAGES.REPORTS_ICONS.CSV
                }
                alt='CSV Completo'
              />
            </div>
            {csvFullIsChecked && (
              <div className={classes.checkIcon}>
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  width='20'
                  height='20'
                  viewBox='0 0 24 24'
                  fill='currentColor'>
                  <circle cx='12' cy='12' r='10' fill='currentColor' />
                  <path
                    d='M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z'
                    fill='white'
                  />
                </svg>
              </div>
            )}
          </div>

          <div
            className={`${!xls ? classes.hiden : classes.boxInput} ${xlsIsChecked ? classes.selectedBox : ''
              }`}
            onClick={() => setXlsIsChecked(!xlsIsChecked)}>
            <Typography className={classes.labelTop}>XLS</Typography>
            <div className={classes.divider} />
            <div className={classes.iconContainer}>
              <img
                className={classes.fileIcon}
                src={
                  xlsIsChecked
                    ? IMAGES.REPORTS_ICONS.XLS_CHECKED
                    : IMAGES.REPORTS_ICONS.XLS
                }
                alt='CSV Completo'
              />
            </div>
            {xlsIsChecked && (
              <div className={classes.checkIcon}>
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  width='20'
                  height='20'
                  viewBox='0 0 24 24'
                  fill='currentColor'>
                  <circle cx='12' cy='12' r='10' fill='currentColor' />
                  <path
                    d='M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z'
                    fill='white'
                  />
                </svg>
              </div>
            )}
          </div>
        </Grid>

        {simplePdfIsChecked && (
          <>
            <Box p={1}>
              <Typography>
                Escolha em qual orientação você deseja exportar seu arquivo:
              </Typography>
            </Box>
            <Grid
              className={classes.contentBoxs}
              container
              xl={12}
              lg={12}
              md={12}
              sm={12}
              xs={12}>
              <Box
                className={`${classes.boxInput} ${simplePdfOrientation === 'vertical' ? classes.selectedBox : ''
                  }`}
                onClick={() => setSimplePdfOrientation('vertical')}>
                <Typography className={classes.labelTop}>Vertical</Typography>
                <Box className={classes.divider} />
                <Box
                  className={clsx(classes.iconContainer, {
                    [classes.horizontalChek]:
                      simplePdfOrientation === 'vertical',
                  })}>
                  <DefaultDocument width='1.75rem' height='1.75rem' />
                </Box>
              </Box>

              <Box
                className={`${classes.boxInput} ${simplePdfOrientation === 'horizontal'
                  ? classes.selectedBox
                  : ''
                  }`}
                onClick={() => setSimplePdfOrientation('horizontal')}>
                <Typography className={classes.labelTop}>Horizontal</Typography>
                <Box className={classes.divider} />
                <Box
                  className={clsx(classes.iconContainer, {
                    [classes.horizontalChek]:
                      simplePdfOrientation === 'horizontal',
                  })}>
                  <HorizontalDocument width='1.75rem' height='1.75rem' />
                </Box>
              </Box>
            </Grid>
          </>
        )}

        <Box className={classes.contentButtons}>
          <Button
            onClick={() => {
              if (setIsPrinting) setIsPrinting(false);
              dispatch(
                setClose({
                  open: false,
                }),
              );
            }}>
            cancelar
          </Button>

          <Button
            type='submit'
            disabled={
              (!pdfIsChecked &&
                !csvIsChecked &&
                !csvFullIsChecked &&
                !xlsIsChecked &&
                !simplePdfIsChecked) ||
              (simplePdfIsChecked && simplePdfOrientation === null)
            }
            className={
              (!pdfIsChecked &&
                !csvIsChecked &&
                !csvFullIsChecked &&
                !xlsIsChecked &&
                !simplePdfIsChecked) ||
                (simplePdfIsChecked && simplePdfOrientation === null)
                ? classes.notAdd
                : classes.add
            }
            onClick={() => {
              if (pdf && pdfIsChecked) {
                if (beforePrint) beforePrint();
                if (isMounted === undefined) {
                  if (setIsPrinting) setIsPrinting(true);
                  handlePrintPdf();
                } else {
                  dispatch(
                    setSecondOpenLoading({
                      title:
                        'Carregando todos os dados da tabela para montar o pdf',
                    }),
                  );
                }
              }
              if (csv && csvIsChecked) handleDownloadCsv();
              if (csvFull && csvFullIsChecked && handleDownloadCsvFull) {
                handleDownloadCsvFull();
              }
              if (xls && xlsIsChecked) handleDownloadXls();
              if (simplePdfIsChecked && simplePdfOrientation !== null) {
                setPdfTextLoading(true);
              }
            }}>
            baixar
          </Button>
        </Box>
      </Grid>
    </>
  );
};

export default Dialogue;
export { Dialogue };
